import script from "./checkAuth.vue?vue&type=script&lang=js"
export * from "./checkAuth.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__